import React from 'react';
import { MapPinIcon } from '@/components/icons';
import { getSignedMediaUrl } from '@/lib/utils';

interface VenueInfoProps {
  business?: {
    name: string;
    description?: string;
    location?: {
      address_line1: string;
      city: string;
    };
    card_image_id?: string | null;
  } | null;
  eventDescription?: string;
}

const VenueInfo: React.FC<VenueInfoProps> = ({ business, eventDescription }) => {
  return (
    <div className="mt-8 bg-gray-900/30 border border-gray-800 rounded-xl p-6">
      <h3 className="text-xl font-semibold mb-4">About {business?.name || 'Event Venue'}</h3>
      <div className="space-y-3">
        {business?.location && (
          <div className="flex items-start gap-3">
            <div className="mt-1 flex-shrink-0">
              <MapPinIcon />
            </div>
            <div className="text-sm text-gray-400">
              {business.location.address_line1}, {business.location.city}
            </div>
          </div>
        )}
        <p className="text-gray-400 text-sm leading-relaxed">
          {business?.description || eventDescription}
        </p>
        {business?.card_image_id && business.card_image_id !== '00000000-0000-0000-0000-000000000000' && (
          <div className="mt-4">
            <img
              src={getSignedMediaUrl(business.card_image_id, 'image').url}
              alt={business.name}
              className="w-full h-32 object-cover rounded-lg"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default VenueInfo;
